import { FetchAPI } from '@3m5/sm_publish-frontend-api'

const xf2mTokenKey = 'X-F2M-AuthToken'

// in the unlikely case of "sessionStorage.setItem(undefined)" -> undefined will be set as string
// this should not happen, but it did while using aws functions which should have returned a string
// to prevent corrupt headers, we have to cleanup the getters or setters

export const GetXf2mToken = () => {
  const xf2mToken = sessionStorage.getItem(xf2mTokenKey)
  return xf2mToken === 'undefined' ? null : xf2mToken
}
export const SetXf2mToken = (token: string) => sessionStorage.setItem(xf2mTokenKey, token)

/**
 * Extended fetch API method to handles:
 * - XSRF tokens
 */
const smModuleFetchApi = (fetch: FetchAPI): FetchAPI => async (url: RequestInfo, init: RequestInit | undefined): Promise<Response> => {
  const xf2mToken = GetXf2mToken()

  const requestInit = {
    ...init,
    credentials: 'include' as const, // same-origin
    headers: {
      ...(init ? init.headers : undefined),
      ...(xf2mToken ? { 'X-F2M-AuthToken': xf2mToken } : undefined),
    },
  }

  // execute request
  const response = await fetch(url, requestInit)

  // check if we have a Xf2m token in the http response header
  const newXsrfToken = response.headers.get('X-F2M-AuthToken')
  if (newXsrfToken) SetXf2mToken(newXsrfToken)
  return response
}

export default smModuleFetchApi
